import { h, Component, Fragment } from "preact";
import Observer from "../../utils/observer";
// import {FiltersRow, InputRow, SelectRow} from "../../utils/table-utils";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import Admin from "../../../../services/admin";
import Config from "../../config";
import User from "../../../../services/user";
import Session from "../../utils/session";
import PageDataFeed from "../../../../services/page-data-feed";

import * as I from "../../utils/icons";
import Awrabet, {
    LoginContent as AwrabetLoginContent,
    LoginForm as AwrabetLoginForm,
    RecoveryForm as AwrabetRecoveryForm,
} from "../../../awrabet/desktop-components/user/login-popup.jsx";

export default class LoginPopup extends Awrabet {
    render() {
        if (!this.state.visible)
            return null;
        return <Overlay onClick={e => this.close()}>
            <SmallModal>
                <ModalHeader>
                    <CloseButton onClick={e => this.close()} />
                    <ModalLogo />
                </ModalHeader>
                <LoginContent />
            </SmallModal>
        </Overlay>
    }
}

export class LoginContent extends AwrabetLoginContent {
    render() {
        return <div>
            {!this.state.recovery? <LoginForm /> : <RecoveryForm />}
            {!this.state.recovery
                ? <div class="w-full px-2 py-3 text-center text-sm text-slate-300 flex items-center justify-center">
                    <a href="javascript:void(0);" onClick={e => this.setState({recovery: true})} class="grow-0 text-right"><Trans>Forgotten password ?</Trans></a>
                </div>
                : <div class="w-full px-2 py-3 text-center text-sm text-slate-300 flex items-center justify-center">
                    <a href="javascript:void(0);" onClick={e => this.setState({recovery: false})} class="grow-0 text-right"><Trans>Back to login</Trans></a>
                </div>}
        </div>;
    }
}


class LoginForm extends AwrabetLoginForm {
    state = {
		error: null,
		sending: false,
        step: 'login', // 'login', 'otp', 'final'
        credentials: null,
	};

    async onSubmit(e) {
        e.preventDefault();
        if (this.state.sending) return;

        this.setState({ sending: true, error: null });
        const formData = new FormData(this.form);
        const username = formData.get('username').trim();
        const password = formData.get('password');

        try {
            await Session.loginPromise(username, password);
            Observer.notify('hide-user-login', {});
            this.setState({ sending: false });
            PageDataFeed.rerender();
        } catch (err) {
            if (err.error === 'link-sent') {
                this.setState({
                    step: 'otp',
                    credentials: { username, password },
                    error: null,
                    sending: false,
                });
            } else {
                this.setState({ error: err.error || err.msg || err, sending: false });
            }
        }
    }

    async handleOtpSubmit(e) {
        e.preventDefault();
        if (this.state.sending) return;

        this.setState({ sending: true, error: null });
        const otpForm = new FormData(this.form);
		const otp = otpForm.get('otp');

        try {
            await User.firstLoginVerifyOTP(otp, this.state.credentials.username, this.state.credentials.password);
            this.setState({ step: 'final', sending: false });
            setTimeout(() => {
                Observer.notify('hide-user-login', {});
                PageDataFeed.rerender();
            }, 2000);
        } catch (err) {
            this.setState({ error: err.error || err, sending: false });
        }
    }

    renderError() {
        if (!this.state.error) return null;
        let errorMessage;
        switch (this.state.error) {
            case 'login-wrong-otp':
                errorMessage = <Trans>The entered OTP is incorrect.</Trans>;
                break;
            case 'login-wrong-credentials':
                errorMessage = <Trans>Incorrect username or password.</Trans>;
                break;
            default:
                errorMessage = this.state.error;
        }

        return (
            <div class="w-full px-2 text-center pt-3 mb-2">
                <div class="bg-gray-200 border py-2 relative rounded text-base text-center text-red-600 w-full">
                    <div class="-top-1/3 absolute bg-red-500 border border-red-600 flex font-bold h-8 items-center justify-center left-2 rounded-full text-white text-xl w-8">!</div>
                    <span>{errorMessage}</span>
                </div>
            </div>
        );
    }

    renderLoginForm() {
        return <form ref={ref => this.form = ref} onSubmit={e => this.onSubmit(e)}>
            <FormRow>
                <InputLabel>Phone Number</InputLabel>
                <HorizontalInputs>
                    <SmallInput value="ET +251" disabled={true} autocomplete="tel-country-code" class="w-20 bg-slate-200 text-slate-500 border-slate-300" />
                    <Input class="grow" name="username" required={true} autocomplete="tel-national" />
                </HorizontalInputs>
            </FormRow>
            <FormRow>
                <InputLabel>Password</InputLabel>
                <Input placeholder={window.Translation(msg`Password`)} class="grow" type="password" name="password" required={true} autocomplete="new-password" />
            </FormRow>
            <div class="w-full px-2 text-center pt-3 mt-2">
                <button type="submit" disabled={this.state.sending} class="w-full bg-amber-400 text-amber-950 py-2 text-center text-base font-bold uppercase hover:bg-amber-600 disabled:opacity-50">
                    {this.state.sending ? <Trans>Loading...</Trans> : <Trans>Login</Trans>}
                </button>
            </div>
        </form>
    }

    renderOtpForm() {
        return <form ref={ref => this.form = ref} onSubmit={e => this.handleOtpSubmit(e)}>
             <div class="p-4 text-sm text-center"><Trans>We have sent you an SMS with a verification code.</Trans></div>
            <FormRow>
                <InputLabel>OTP Code</InputLabel>
                <HorizontalInputs>
                    <Input class="grow" name="otp" required={true} autocomplete="one-time-code" inputmode="numeric" />
                </HorizontalInputs>
            </FormRow>
            <div class="w-full px-2 text-center pt-3 mt-2">
                <button type="submit" disabled={this.state.sending} class="w-full bg-amber-400 text-amber-950 py-2 text-center text-base font-bold uppercase hover:bg-amber-600 disabled:opacity-50">
                    {this.state.sending ? <Trans>Verifying...</Trans> : <Trans>Verify</Trans>}
                </button>
            </div>
        </form>
    }

    renderFinalStep() {
        return <div class="p-4 text-center">
            <div class="p-4 text-sm"><Trans>You will be logged in shortly.</Trans></div>
        </div>;
    }

    render({onFinish}) {
        let formContent;
        switch (this.state.step) {
            case 'otp':
                formContent = this.renderOtpForm();
                break;
            case 'final':
                formContent = this.renderFinalStep();
                break;
            case 'login':
            default:
                formContent = this.renderLoginForm();
                break;
        }

        return <div class="flex flex-col gap-2">
            <div class="text-base uppercase w-full text-center py-2">
                {this.state.step === 'otp' ? <Trans>Verify OTP</Trans> : <Trans>Login</Trans>}
            </div>
            <div class="w-full px-4 text-center">
                {this.state.sending && <div class="w-full px-2 text-center pt-3 mb-2">
                        <i class="fa text-2xl fa-spin fa-spinner"/>
                    </div>}
                {this.renderError()}
                {formContent}
            </div>
        </div>
    }
}

class RecoveryForm extends AwrabetRecoveryForm {
    stepOneForm() {
        return <form ref={ref => this.form = ref} onSubmit={e => this.stepOneSubmit(e)}>
            <FormRow>
                <InputLabel>Phone Number</InputLabel>
                <HorizontalInputs>
                    <SmallInput value="ET +251" disabled={true} autocomplete="tel-country-code" class="w-20 bg-slate-200 text-slate-500 border-slate-300" />
                    <Input class="grow" name="username" required={true} autocomplete="tel-national" onInput={e => this.setState({ username: e.target.value })} value={this.state.username || ''} />
                </HorizontalInputs>
            </FormRow>

            <div class="w-full px-2 text-center pt-3 mt-2">
                <button type="submit" class="w-full bg-amber-400 text-amber-950 py-2 text-center text-base font-bold uppercase hover:bg-amber-600">
                    <Trans>Send SMS OTP</Trans>
                </button>
            </div>
        </form>;
    }

    stepTwoForm() {
        return <form ref={ref => this.form = ref} onSubmit={e => this.stepTwoSubmit(e)}>
            <FormRow>
                <InputLabel>OTP Code</InputLabel>
                <HorizontalInputs>
                    <Input class="grow" name="otp" required={true} />
                </HorizontalInputs>
            </FormRow>

            <div class="w-full px-2 text-center pt-3 mt-2">
                <button type="submit" class="w-full bg-amber-400 text-amber-950 py-2 text-center text-base font-bold uppercase hover:bg-amber-600">
                    <Trans>Check OTP</Trans>
                </button>
            </div>
        </form>;
    }

    stepThreeForm() {
        return <form ref={ref => this.form = ref} onSubmit={e => this.stepThreeSubmit(e)}>
            <FormRow>
                <InputLabel>Password</InputLabel>
                <Input placeholder={window.Translation(msg`Password`)} class="grow" type="password" name="password" required={true} autocomplete="new-password" />
            </FormRow>
            <FormRow>
                <InputLabel>Repeat Password</InputLabel>
                <Input placeholder={window.Translation(msg`Repeat Password`)} class="grow" type="password" name="confirmPassword" required={true} autocomplete="new-password" />
            </FormRow>

            <div class="w-full px-2 text-center pt-3 mt-2">
                <button type="submit" class="w-full bg-amber-400 text-amber-950 py-2 text-center text-base font-bold uppercase hover:bg-amber-600">
                    <Trans>Update Password</Trans>
                </button>
            </div>
        </form>;
    }

    stepFourForm() {
        return <div>
            <div class="w-full px-2 text-center pt-3 mb-2">
                <div class="bg-gray-200 border py-2 relative rounded text-base text-center text-green-600 w-full">
                    <div class="-top-1/3 absolute bg-green-600 border border-green-800 flex font-bold h-8 items-center justify-center left-2 rounded-full text-white text-xl w-8">!</div>
                    <span><Trans>Password updated with success!</Trans></span>
                </div>
            </div>
        </div>;
    }

    render({onFinish}) {
        console.info(this.state.error);
        console.info(this.errors);

        return <div class="flex flex-col gap-2">
            <div class="text-base uppercase w-full text-center py-2"><Trans>Password Recovery</Trans></div>
            <div class="w-full px-4 text-center">
                {!this.state.sending
                    ? !!this.state.error && <div class="w-full px-2 text-center pt-3 mb-2">
                    <div class="bg-gray-200 border py-2 relative rounded text-base text-center text-red-600 w-full">
                        <div class="-top-1/3 absolute bg-red-500 border border-red-600 flex font-bold h-8 items-center justify-center left-2 rounded-full text-white text-xl w-8">!</div>
                        <span>{window.Translation(this.errors[this.state.error])}</span>
                    </div>
                </div>
                    : <div class="w-full px-2 text-center pt-3 mb-2">
                        <i class="fa text-2xl fa-spin fa-spinner"/>
                    </div>}

                {this.state.step === 1 && this.stepOneForm()}
                {this.state.step === 2 && this.stepTwoForm()}
                {this.state.step === 3 && this.stepThreeForm()}
                {this.state.step === 4 && this.stepFourForm()}
            </div>
        </div>
    }
}

function Overlay({onClick, children}) {
    return <div class="fixed top-0 left-0 right-0 bottom-0 z-50 bg-slate-800/50 flex items-center justify-center" onClick={e => e.target == e.currentTarget ? onClick(e) : null}>
        {children}
    </div>
}

export function SmallModal({children}) {
    return <div class="w-full max-w-sm overflow-auto rounded-lg flex flex-col bg-harif-800 text-slate-100 border border-blue-whale-950">
        {children}
    </div>
}

export function ModalHeader({children}) {
    return <header class="relative">
        {children}
    </header>
}
export function CloseButton({onClick}) {
    return <a onClick={onClick} class="top-2 right-2 absolute w-6 h-6 flex items-center justify-center cursor-pointer">
        <I.CloseIcon class="h-3 fill-current" />
    </a>
}
export function ModalLogo({children}) {
    return <div class="p-2 h-24 w-full">
        <img src={Config.logourl} alt={Config.title} class="object-contain w-full h-full" />
    </div>;
}

export function FormRow({children, ...props}) {
    return <div class={"text-left "+props['class']}>
        {children}
    </div>
}
export function InputLabel({children, ...props}) {
    return <label {...props} class={"w-full text-xs "+props['class']}>
        {children}
    </label>
}
export function HorizontalInputs({children, ...props}) {
    return <div class={"flex "+props['class']}>
        {children}
    </div>
}
export function SmallInput({children, ...props}) {
    return <input {...props} class={"border h-8 leading-8 py-2 px-3 bg-slate-100 text-slate-950 text-sm "+props['class']} />
}
export function Input({children, ...props}) {
    return <input {...props} class={"border h-8 w-full leading-8 py-2 px-3 bg-slate-100 text-slate-950 text-sm "+props['class']} />
}

//> Eof